module.exports = __webpack_public_path__ + "static/media/dot_007CBA_a.57d80030.svg";